var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { concatClassNames } from "../../utils/Functions";
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleMouseWheel = function (e) {
            var _a = _this.props, disabled = _a.disabled, loading = _a.loading, onMouseWheel = _a.onMouseWheel, onMouseDown = _a.onMouseDown;
            if (e.button === 1 && onMouseWheel && !disabled && !loading)
                onMouseWheel(e);
            else if (onMouseDown)
                onMouseDown(e);
        };
        _this.render = function () {
            var _a = _this.props, outline = _a.outline, color = _a.color, type = _a.type, size = _a.size, loading = _a.loading, shape = _a.shape, className = _a.className, style = _a.style, disabled = _a.disabled, children = _a.children, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, buttonColor = color || "blue", buttonType = type || "button", buttonSize = size || "medium", buttonShape = shape || "normal", classes = ["dolfo-button", "size-" + buttonSize, "shape-" + buttonShape, "color-" + buttonColor];
            if (outline)
                classes.push("outlined");
            return React.createElement("button", { type: buttonType, disabled: disabled || loading, style: style, className: concatClassNames(classes, className), onClick: !loading && !disabled ? onClick : null, onMouseDown: _this.handleMouseWheel, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
                loading && React.createElement(FontAwesomeIcon, { icon: faSpinner, className: "dolfo-button-spinner", spin: true }),
                " ",
                children);
        };
        return _this;
    }
    return Button;
}(React.Component));
export { Button };
